import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass } from "vue"

import { computed, ref, watch } from 'vue'

interface IProps {
  position?: 'right' | 'left' | 'center'
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseOverlay' },
  __name: 'BaseOverlay',
  props: {
    position: { default: 'right' }
  },
  setup(__props: any, { expose: __expose }) {

_useCssVars(_ctx => ({
  "ecb206cc": (computedStyles.value.margin),
  "v3c737d00": (computedStyles.value.transform)
}))


const props = __props

const toggleRef = ref(false)
const triggerRef = ref(false)

function show() {
  triggerRef.value = true
}

function hide() {
  triggerRef.value = false
}

function toggle() {
  triggerRef.value = !toggleRef.value
}

watch(triggerRef, () => {
  setTimeout(() => (toggleRef.value = triggerRef.value), 300)
})

const computedStyles = computed(() => {
  switch (props.position) {
    case 'right':
      return { margin: '0 0 0 auto', transform: 'translateX(100%)' }
    case 'left':
      return { margin: '0 auto 0 0', transform: 'translateX(-100%)' }
    default:
      return { margin: '0 auto', transform: 'scale(0)' }
  }
})

__expose({ show, hide, toggle })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseOverlay transition", { 'BaseOverlay--hidden': !toggleRef.value, 'BaseOverlay--animating': toggleRef.value !== triggerRef.value }])
  }, [
    (_ctx.$q.screen.lt.lg)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "BaseOverlay__backdrop fixed-full transition",
          onClick: hide
        }))
      : _createCommentVNode("", true),
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})